type GridSkeletonProps = {
  rows: number;
  columns: number;
  height?: number;
  className?: React.ComponentProps<"div">["className"];
};

export const GridSkeleton = ({ columns, rows, height = 1, className }: GridSkeletonProps) => {
  return (
    <div
      role="status"
      className={`flex-1 animate-pulse space-y-4 rounded-md border border-neutral-400 p-6 shadow ${
        className || ""
      }`}
    >
      <div className="flex flex-col gap-9">
        {Array(rows)
          .fill(0)
          .map((_, i) => (
            <div key={i} className="flex items-center justify-between gap-9">
              {Array(columns)
                .fill(0)
                .map((_, i) => (
                  <div
                    key={i}
                    style={{ height: `${height}rem` }}
                    className="flex-1 rounded-md bg-neutral-400"
                  />
                ))}
            </div>
          ))}
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

type GenericSkeletonProps = {
  height?: number;
  width?: number;
  className?: string;
};

export const TextSkeleton = ({ height = 1.5, width = 20, className }: GenericSkeletonProps) => {
  return (
    <div
      style={!className ? { height: `${height}rem`, width: `${width}rem` } : {}}
      className={`animate-pulse rounded-md bg-neutral-400 ${className}`}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

type TabPanelSkeletonProps = GenericSkeletonProps & {
  items?: number;
};

export const TabPanelSkeleton = ({ items = 3, height = 1, width = 8 }: TabPanelSkeletonProps) => {
  return (
    <div className="flex animate-pulse items-center justify-between gap-3 rounded-md">
      {Array(items)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            style={{ height: `${height}rem`, width: `${width}rem` }}
            className="flex-1 rounded-md bg-neutral-400"
          />
        ))}
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export const PieSkeleton = ({ height = 44.25, width = 44.25, className }: GenericSkeletonProps) => {
  return (
    <div
      style={{
        height: `${height}rem`,
        width: `${width}rem`,
      }}
      className={`animate-pulse rounded-full bg-neutral-400 ${className}`}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};
